import { authRoutes } from "./auth/routes"
import { booksRoutes } from "./books/routes"

export const moduleRoutes = [...authRoutes, ...booksRoutes]
